import type { ReactNode } from "react";
import { navigate } from "../router";

/** An in-app link: a plain click navigates without a reload; a modified one opens as the browser would. */
export function Link({
  to,
  className,
  current,
  role,
  children,
}: {
  to: string;
  className?: string;
  current?: boolean;
  role?: string;
  children: ReactNode;
}) {
  return (
    <a
      className={className}
      href={to}
      role={role}
      aria-current={current ? "page" : undefined}
      onClick={(e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        navigate(to);
      }}
    >
      {children}
    </a>
  );
}
